import { render } from "./arrows.vue?vue&type=template&id=51b44a10"
import script from "./arrows.vue?vue&type=script&lang=js"
export * from "./arrows.vue?vue&type=script&lang=js"

import "./arrows.vue?vue&type=style&index=0&id=51b44a10&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-testimonial/_components/arrows.vue'],['render',render],['__file',"arrows.vue"]])

export default __exports__